import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "svg-AF-logo_svg__a",
  x: "0",
  y: "0",
  style: {"enable-background":"new 0 0 1024 1024"},
  version: "1.1",
  viewBox: "0 0 1024 1024"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode(".svg-AF-logo_svg__st2{fill:#051039}", -1)
      ]))]),
      _: 1
    })),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "M0 0h1024v1024H0z",
      style: {"fill":"#fff"}
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      id: "svg-AF-logo_svg__b",
      d: "m864.9 386.3-133.4 193c-17.6 25.4-46.1 49.8-80.5 52.5v5.9h148.4c39.4 0 68.1-25.6 87.6-53.9l137-197.5H864.9z",
      style: {"fill":"red"}
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M170.1 386.3 0 637.7h69.4l38.1-57.4H283l21.9 31.4c14 18.8 26.7 26 56.4 26h52.4L239.5 386.3h-69.4zM136.7 536l58.5-88.7L253 536H136.7zM432.4 637.7h74.7v-87.6h191.8V507H507.1v-77.6h196.1v-43.1H432.4v251.4z",
      class: "svg-AF-logo_svg__st2"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "AF-logo"}) } }